import config from '@src/config'
import type { GenericContactSearchRequest } from '@src/service/dto/request/search/GenericContactSearchRequest'
import type { SearchConversationsRequest } from '@src/service/dto/request/search/SearchConversationsRequest'
import type { SearchFilterContactsRequest } from '@src/service/dto/request/search/SearchFilterContactsRequest'
import type { SearchInsightsRequest } from '@src/service/dto/request/search/SearchInsightsRequest'
import type { SearchConversationsResponse } from '@src/service/dto/response/search/SearchConversationsResponse'
import type { SearchFilterContactsResponse } from '@src/service/dto/response/search/SearchFilterContactsResponse'
import type { SearchInsightsResponse } from '@src/service/dto/response/search/SearchInsightsResponse'

import type Transport from '.'
import { HttpTransaction } from './transaction'

export default class SearchClient {
  constructor(private transport: Transport) {}

  conversation(body: SearchConversationsRequest): Promise<SearchConversationsResponse> {
    return this.transport.queue(
      new HttpTransaction({
        method: 'POST',
        url: `${config.SEARCH_SERVICE_URL}search/conversation`,
        body,
      }),
    )
  }

  searchFilterContacts(
    body: SearchFilterContactsRequest,
  ): Promise<SearchFilterContactsResponse> {
    return this.transport.queue(
      new HttpTransaction({
        method: 'POST',
        url: `${config.SEARCH_SERVICE_URL}search/filter`,
        body: {
          includeWhere: {
            contacts: {
              contains: [body.query],
              phoneNumbers: true,
            },
          },
          maxResults: body.maxResults,
        },
      }),
    )
  }

  genericContactSearch(
    body: GenericContactSearchRequest,
  ): Promise<SearchFilterContactsResponse> {
    return this.transport.queue(
      new HttpTransaction({
        method: 'POST',
        url: `${config.SEARCH_SERVICE_URL}search`,
        body,
      }),
    )
  }

  insights(body: SearchInsightsRequest): Promise<SearchInsightsResponse> {
    return this.transport.queue(
      new HttpTransaction({
        method: 'POST',
        url: `${config.SEARCH_SERVICE_URL}search/nps`,
        body,
      }),
    )
  }
}
